export default __webpack_public_path__ + "static/media/V.97f6f212.jpg";